'use strict';

var React = require('react');

var SvgLockMinor = function SvgLockMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 8v-1c0-2.757-2.243-5-5-5s-5 2.243-5 5v1a1 1 0 0 0-1 1v7.5a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5v-7.5a1 1 0 0 0-1-1zm-6 7h2v-4h-2v4zm4-7h-6v-1c0-1.654 1.346-3 3-3s3 1.346 3 3v1z"
  }));
};

exports.SvgLockMinor = SvgLockMinor;
